module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="recipients-list-item"></div>\n<div class="recipients-list-item-remove-button">&#x00d7;</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/share/ShareRecipientDisplayView.tpl
// module id = 2911
// module chunks = 0